export const FETCH_PRODUCTS_BEGIN = 'FETCH_PRODUCTS_BEGIN';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
export const RESET_PRODUCT_DETAILS = 'RESET_PRODUCT_DETAILS';
export const CHANGE_INGREDIENT_VALUE = 'CHANGE_INGREDIENT_VALUE';
export const MOBILE_VIEW_HOW_TO_APPLY = 'MOBILE_VIEW_HOW_TO_APPLY';
export const MOBILE_INGREDIENT_PAGE = 'MOBILE_INGREDIENT_PAGE';
export const CLOSE_MOBILE_VIEW_HOW_TO_APPLY = 'CLOSE_MOBILE_VIEW_HOW_TO_APPLY';
export const CLOSE_MOBILE_INGREDIENT_PAGE = 'CLOSE_MOBILE_INGREDIENT_PAGE'
